import React, { useState } from "react";
import { useSiteData } from "../context/SiteDataContext";

const Portfolio: React.FC = () => {
  const { data } = useSiteData();
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>Portföy</h1>
          <p>
            Tamamladığım projeler ve çalışmalarımı inceleyebilirsiniz
          </p>
        </div>
      </div>

      {/* WEB TASARIM PROJELERI */}
      <section className="section">
        <div className="container">
          <h2 style={{ fontSize: "1.8rem", marginBottom: "32px", display: "flex", alignItems: "center", gap: "12px" }}>
            🎨 Web Tasarım Projeleri
          </h2>
          <div className="portfolio-grid">
            {data.portfolio.map((item) => (
              <div key={item.id} className="portfolio-card">
                <div className="portfolio-image">
                  {item.image ? (
                    <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  ) : (
                    <span className="placeholder">
                      📸 Screenshot yakında eklenecek
                    </span>
                  )}
                </div>
                <div className="portfolio-info">
                  <h3>{item.title}</h3>
                  <p className="domain">{item.domain}</p>
                  <p>{item.description}</p>
                  <div className="portfolio-tags">
                    {item.tags.map((tag, idx) => (
                      <span key={idx}>{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CANLI ALTYAZI VIDEOLARI */}
      {data.videos && data.videos.length > 0 && (
        <section className="section section-light">
          <div className="container">
            <h2 style={{ fontSize: "1.8rem", marginBottom: "32px", display: "flex", alignItems: "center", gap: "12px" }}>
              📺 Canlı Altyazı Çalışmaları
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px" }}>
              {data.videos.map((video) => (
                <div
                  key={video.id}
                  onClick={() => video.url && setSelectedVideo(video.url)}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid var(--border)",
                    cursor: video.url ? "pointer" : "default",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (video.url) {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div style={{ position: "relative", height: "180px", background: "#000", overflow: "hidden" }}>
                    {video.url ? (
                      <>
                        <video src={video.url} style={{ width: "100%", height: "100%", objectFit: "cover" }} muted preload="metadata" />
                        <div style={{
                          position: "absolute",
                          top: 0, left: 0, right: 0, bottom: 0,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          background: "rgba(0,0,0,0.3)",
                        }}>
                          <div style={{
                            width: "60px", height: "60px",
                            background: "rgba(255,255,255,0.9)",
                            borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: "1.5rem",
                          }}>
                            ▶
                          </div>
                        </div>
                      </>
                    ) : (
                      <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-light)" }}>
                        🎬 Video yakında
                      </div>
                    )}
                  </div>
                  <div style={{ padding: "16px" }}>
                    <h3 style={{ fontSize: "1rem", fontWeight: 700, marginBottom: "6px" }}>{video.title}</h3>
                    <p style={{ color: "var(--text-medium)", fontSize: "0.85rem", lineHeight: "1.5" }}>{video.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* VIDEO MODAL */}
      {selectedVideo && (
        <div
          onClick={() => setSelectedVideo(null)}
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 9999,
            padding: "24px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "900px",
            }}
          >
            <button
              onClick={() => setSelectedVideo(null)}
              style={{
                position: "absolute",
                top: "-40px", right: "0",
                background: "none", border: "none",
                color: "white", fontSize: "2rem",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
            <video
              src={selectedVideo}
              controls
              autoPlay
              style={{
                width: "100%",
                borderRadius: "12px",
                background: "#000",
              }}
            />
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="section">
        <div className="container" style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: "2rem", marginBottom: "16px" }}>
            Size de Projelerinizde Yardımcı Olabiliriz
          </h2>
          <p
            style={{
              color: "var(--text-medium)",
              maxWidth: "500px",
              margin: "0 auto 32px",
            }}
          >
            Ne tür bir siteye ihtiyacınız varsa birlikte hayata geçirelim.
          </p>
          <a href="/iletisim" className="btn-primary">
            Teklif Al
          </a>
        </div>
      </section>
    </>
  );
};

export default Portfolio;
